import {
  CloseOutlineIcon,
  ExitFullScreenOutlineIcon,
  FullScreenOutlineIcon,
  MinusOutlineIcon,
} from '@carboncopyco/icons';
import { useEffect, useState } from 'react';
import WindowTitleBarDropdown from './WindowsTitleBarDropdown';

const WindowsTitleBar = ({
  iconsColor = 'text-ds-natural-100',
}: {
  iconsColor?: string;
}) => {
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    window.dsDesktop.view.onToggleFullScreen(({ isFullScreen }) =>
      setIsMaximized(isFullScreen)
    );
  }, []);

  const windowsTitleBarButtons = [
    {
      key: 'dropdownMenu',
      children: <WindowTitleBarDropdown iconColor={iconsColor} />,
    },
    {
      key: 'minimize',
      children: <MinusOutlineIcon size={20} />,
      onClick: () => window.dsDesktop?.app.minimize(),
    },
    {
      key: 'maximize',
      children: isMaximized ? (
        <ExitFullScreenOutlineIcon size={20} />
      ) : (
        <FullScreenOutlineIcon size={20} />
      ),
      onClick: () => {
        window.dsDesktop?.app.toggleFullScreen(isMaximized);
      },
    },
  ];

  return (
    <div className="flex flex-row">
      {windowsTitleBarButtons.map((titleBarButton) => (
        <div
          key={titleBarButton.key}
          className={`min-h-9 w-10 items-center justify-center cursor-pointer flex ${iconsColor} px-2.5 hover:bg-ds-natural-100/25`}
          onClick={titleBarButton.onClick}
        >
          {titleBarButton.children}
        </div>
      ))}
      <div
        className={`min-h-9 w-10 items-center justify-center cursor-pointer flex ${iconsColor} px-2.5 hover:bg-ds-danger-400`}
        onClick={() =>
          window.dsDesktop?.app.closeApp({
            forceQuit: true,
          })
        }
      >
        <CloseOutlineIcon size={20} />
      </div>
    </div>
  );
};

export default WindowsTitleBar;
